<script lang="ts" setup>
import ConfirmDialog from 'primevue/confirmdialog'
</script>

<template>
  <NuxtLayout>
    <!-- <NuxtLoadingIndicator /> -->
    <ConfirmDialog />
    <ConfirmDialog group="inline" />
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
* {
  touch-action: manipulation;
}

body {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
